import { axios, AxiosResponse } from "@sdk/axios";
import { SDKConfig } from "@sdk/default-sdk-config";
import { EntityServices } from "@sdk/utils/entity.service";
import { iLedger } from "./ledgers-models";

export type iLedgerBalance = {
  balance: number;
  currency: string;
};

export class LedgersServices {
  configure(config: { basePath?: string; token?: string }) {
    Object.assign(this.config, config);
  }
  constructor(protected config: { basePath: string; token: string }) {
    this.ledgers.configure(config);
  }

  ledgers = new EntityServices<iLedger>(SDKConfig, "ledgers", {});

  async getBalance(id: string): Promise<iLedgerBalance> {
    const results: AxiosResponse<iLedgerBalance> = await axios.get(
      this.config.basePath + `/ledgers/${id}/balance`,
      {
        headers: {
          Authorization: this.config.token,
        },
      }
    );
    return results.data;
  }
}

